import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { IOcField } from './types'

interface Props {
  config: any
  field: ControllerRenderProps<FieldValues, string>
  ocField: IOcField
}

export function parseComponentConfig({ config, field, ocField }: Props) {
  const {
    formPropMap = {},
    configPropMap = {},
    propValues = {},
    component,
  } = config

  const Component = component

  const props: Record<string, any> = {}

  for (const key in formPropMap) {
    props[key] = field?.[formPropMap[key]]
  }

  for (const key in configPropMap) {
    props[key] = ocField[configPropMap[key]]
  }

  for (const key in propValues) {
    const value = propValues[key]
    props[key] = value
  }

  props.isRequired = ocField?.config?.required
  props.disabled = ocField?.config?.disable
  props.fieldDependency = ocField?.config?.fieldDependency
  props.autoCompleteLength = ocField?.config?.autoCompleteLength
  props.helperText = ocField?.config?.helperText
  return { Component, componentProps: props }
}
